import { Col, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { useTranslation } from "react-i18next";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import sidebar from "../../utils/sidebar";
import Select from "react-select";
import SelectCustomStyles from "../../../../utils/styles/reactSelect";
import FixedSave from "../../../../components/Actions/FixedSave";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import countries, { countryCodeOptions } from "../../../../data/countries";
import { get, post } from "../../../../utils/helpers/api";
import { toast } from "react-toastify";
import CustomSelect from "../../../../components/Forms/CustomSelect";

function CreateLeadPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [initLoading, setInitLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);
  const [companySettings, setCompanySettings] = useState({});
  const [leadData, setLeadData] = useState({
    name: state?.leadData?.name || '',
    employee_id: state?.leadData?.employee_id || null,
    firstname: state?.leadData?.firstname || '',
    lastname: state?.leadData?.lastname || '',
    company_name: state?.leadData?.company_name || '',
    gender: state?.leadData?.gender || '',
    status: state?.leadData?.status || '',
    source: state?.leadData?.source || '',
    type: state?.leadData?.type || '',
    expected_value: state?.leadData?.expected_value,
    expected_close_date: state?.leadData?.expected_close_date,
    expected_value: state?.leadData?.expected_value,
    probability: state?.leadData?.probability,
    email: state?.leadData?.email || '',
    country_code: state?.leadData?.country_code || '',
    phone_number: state?.leadData?.phone_number || '',
    website: state?.leadData?.website || '',
    whatsapp_country_code: state?.leadData?.whatsapp_country_code || '',
    whatsapp: state?.leadData?.whatsapp || '',
    country: state?.leadData?.country || '',
    state: state?.leadData?.state || '',
    city: state?.leadData?.city || '',
    zip_code: state?.leadData?.zip_code || ''
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    setInitLoading(true);
    const data = await get('/crm/leads/create');
    if (data.success) {
      setEmployeesData(data.employees);
      setCompanySettings(data.company_settings);
      setInitLoading(false);
    }
  };

  const saveLead = async () => {
    setSaveLoading(true);
    const url = id ? '/crm/leads/update/' + id : '/crm/leads/store';
    const data = await post(url, { ...leadData });
    if (data.success) {
      navigate('/crm/leads/view/' + data.lead.id, { state: { leadData: data.lead } });
    } else {
      toast.error(data.message || t('common.somethingWentWrong'));
    }
    setSaveLoading(false);
  };

  const statusOptions = [
    { value: 'new', label: t('crm.new') },
    { value: 'contacted', label: t('crm.contacted') },
    { value: 'qualified', label: t('crm.qualified') },
    { value: 'quotation_sent', label: t('crm.quotation_sent') },
    { value: 'negotiation', label: t('crm.negotiation') },
    { value: 'won', label: t('crm.won') },
    { value: 'lost', label: t('crm.lost') }
  ];

  const typeOptions = [
    { value: 'client', label: t('crm.client') },
    { value: 'consultant', label: t('crm.consultant') },
    { value: 'partner', label: t('crm.partner') }
  ];

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader
          breadcrumb={[t('crm.leads'), id ? t('crm.editLead') : t('crm.newLead')]}
          onBack={() => navigate('/crm/leads')}
        />

        <div className="subheader-page-content scrollable">
          <h5 className="fw-bold mb-3">{t('crm.leadInfo')}</h5>
          <Row>
            <Col md="6" className="mb-3">
              <Label>{t('crm.leadName')} <span className="text-danger">*</span></Label>
              <Input value={leadData.name} onChange={(e) => setLeadData({ ...leadData, name: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.leadOwner')} </Label>
              <Select
                options={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname }))}
                value={employeesData.map(e => ({ value: e.id, label: e.firstname + ' ' + e.lastname })).find(o => o.value === leadData.employee_id) || null}
                onChange={selected => setLeadData({ ...leadData, employee_id: selected ? selected.value : null })}
                styles={SelectCustomStyles}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('contact.firstName')} </Label>
              <Input value={leadData.firstname} onChange={(e) => setLeadData({ ...leadData, firstname: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('contact.lastName')} </Label>
              <Input value={leadData.lastname} onChange={(e) => setLeadData({ ...leadData, lastname: e.target.value })} />
            </Col>
            <Col md="12" className="mb-3">
              <Label>{t('settings.companyNameLabel')}: </Label>
              <Input value={leadData.company_name} onChange={(e) => setLeadData({ ...leadData, company_name: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('hr.gender')} </Label>
              <Input type="select" value={leadData.gender} onChange={e => setLeadData({ ...leadData, gender: e.target.value })}>
                <option value="">{t('common.select')}</option>
                <option value="male">{t('hr.male')}</option>
                <option value="female">{t('hr.female')}</option>
              </Input>
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('common.status')} </Label>
              <Select
                value={statusOptions.find(o => o.value === leadData.status) || null}
                onChange={(selected) => setLeadData({ ...leadData, status: selected.value })}
                options={statusOptions}
                styles={SelectCustomStyles}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.source')} </Label>
              <CustomSelect
                value={leadData.source}
                onChange={(selected, objectData) => setLeadData({ ...leadData, source: selected ? selected.label : '' })}
                module="crm/settings/lead-sources"
                placeholder={t('crm.searchSourcePlaceholder')}
                createLink="/crm/settings"
                responseKey="lead_sources"
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.leadType')} </Label>
              <Select
                value={typeOptions.find(o => o.value === leadData.type) || null}
                onChange={(selected) => setLeadData({ ...leadData, type: selected.value })}
                options={typeOptions}
                styles={SelectCustomStyles}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.expectedValue')} </Label>
              <InputGroup>
                <InputGroupText>{ companySettings?.sales?.base_currency }</InputGroupText>
                <Input 
                  value={leadData.expected_value}
                  onChange={(e) => setLeadData({ ...leadData, expected_value: e.target.value })}
                />
              </InputGroup>
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.probability')} </Label>
              <InputGroup>
                <InputGroupText>%</InputGroupText>
                <Input 
                  value={leadData.probability}
                  onChange={(e) => setLeadData({ ...leadData, probability: e.target.value })}
                />
              </InputGroup>
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('crm.expectedCloseDate')} </Label>
              <Input 
                type="date"
                value={leadData.expected_close_date}
                onChange={(e) => setLeadData({ ...leadData, expected_close_date: e.target.value })}
              />
            </Col>
          </Row>

          <h5 className="fw-bold mb-3 mt-2">{t('crm.contactInfo')}</h5>
          <Row>
            <Col md="6" className="mb-3">
              <Label>{t('common.email')} </Label>
              <Input type="email" value={leadData.email} onChange={(e) => setLeadData({ ...leadData, email: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('common.phone')} </Label>
              <div className="d-flex gap-2">
                <div style={{ width: 140, flexShrink: 0 }}>
                  <Select
                    options={countryCodeOptions}
                    value={countryCodeOptions.find((o) => o.value === leadData.country_code) || null}
                    onChange={(selected) =>
                      setLeadData({ ...leadData, country_code: selected ? selected.value : "" })
                    }
                    styles={SelectCustomStyles}
                  />
                </div>
                <Input
                  type="tel"
                  name="phone_number"
                  placeholder={t('common.phoneNumberPlaceholder')}
                  value={leadData.phone_number}
                  onChange={(e) => setLeadData({ ...leadData, phone_number: e.target.value })}
                />
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('settings.website')} </Label>
              <Input type="url" value={leadData.website} onChange={(e) => setLeadData({ ...leadData, website: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('profile.whatsapp')} </Label>
              <div className="d-flex gap-2">
                <div style={{ width: 140, flexShrink: 0 }}>
                  <Select
                    options={countryCodeOptions}
                    value={countryCodeOptions.find((o) => o.value === leadData.whatsapp_country_code) || null}
                    onChange={(selected) =>
                      setLeadData({ ...leadData, whatsapp_country_code: selected ? selected.value : "" })
                    }
                    styles={SelectCustomStyles}
                  />
                </div>
                <Input
                  type="tel"
                  name="whatsapp"
                  placeholder={t('common.phoneNumberPlaceholder')}
                  value={leadData.whatsapp}
                  onChange={(e) => setLeadData({ ...leadData, whatsapp: e.target.value })}
                />
              </div>
            </Col>
          </Row>

          <h5 className="fw-bold mb-3 mt-2">{t('common.address')}</h5>
          <Row>
            <Col md="6" className="mb-3">
              <Label>{t('common.country')} </Label>
              <Select
                value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === leadData.country) || null}
                onChange={(selected) => setLeadData({ ...leadData, country: selected ? selected.value : '' })}
                options={countries.map((c) => ({ value: c.slug, label: c.name }))}
                styles={SelectCustomStyles}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('address.state')} </Label>
              <Input value={leadData.state} onChange={(e) => setLeadData({ ...leadData, state: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('address.city')} </Label>
              <Input value={leadData.city} onChange={(e) => setLeadData({ ...leadData, city: e.target.value })} />
            </Col>
            <Col md="6" className="mb-3">
              <Label>{t('address.zipCode')} </Label>
              <Input value={leadData.zip_code} onChange={(e) => setLeadData({ ...leadData, zip_code: e.target.value })} />
            </Col>
          </Row>
        </div>
      </div>

      <FixedSave 
        onSave={saveLead} 
        loading={saveLoading} 
        disabled={initLoading || saveLoading || !leadData.name} 
      />
    </SidebarLayout>
  );
}

export default CreateLeadPage;
